export default __webpack_public_path__ + "static/media/fastclix_lancing_kit@2x.090f9611.png";